import { Component} from '@angular/core';

@Component({
    selector: 'payMethod-main',
    templateUrl: './payMethod-main.tmpl.html'
})

export class PayMethodMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  